<template>
	<div style="height: 96%;">
		<div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案验证</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>凭证验证</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- <el-divider></el-divider> -->

		<div class="container">
			<el-tabs v-model="voucherValidationTabs">
				<el-tab-pane label="记账凭证" name="1">
					<div style="display: flex;padding-top: 12px;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">审核状态</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in accVoucherAuditStatusImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="($event) => auditStatusImgClickFun($event, index, 'accVoucherAuditStatusImgList')">
						</div>
					</div>
					<el-divider></el-divider>
					<div style="display: flex;">
						<div style="width: 60%;">
							<el-button plain @click="setOriVoucherPassed"><i class="el-icon-check" style="color: #84b944;font-size: 14px;font-weight: bold;"></i> 审核通过</el-button>
							<el-button plain @click="setOriVoucherDeny"><i class="el-icon-close" style="color: #d0303e;font-size: 14px;font-weight: bold;"></i> 审核拒绝</el-button>
							<el-button plain @click="deleteOriVoucher" style="width: 80px;">删除</el-button>
						</div>
						<div style="width: 40%;">
							<div style="float: right;">
								<el-input v-model="accVoucherValidationSearchName" placeholder="凭证号码、价税合计、所属实体" style="width:350px;margin-bottom:5px" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryAccVoucherValidationData"/>
							</div>
						</div>
					</div>
					<div style="margin-top: 8px;">
						<el-row>
							<el-col :span="16">
								<el-table ref="accVoucherValidationTable" :data="accVoucherValidationTableData" border stripe class="table" @row-click="(row) => clickRowByChecked('accVoucherValidationTable', row)" height="500px"  :highlight-current-row="true">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="voucherType" label="凭证类型" align="center" width="100">
										<template>
											<div v-for="(imgObj, index) in formatAccVoucherTypeImgList" :key="index">
												<img :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="voucherNo" label="凭证号码" sortable="true"></el-table-column>
									<el-table-column prop="amount" label="凭证金额" sortable="true" :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证日期" sortable="true" :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
									<el-table-column prop="companyName" label="所属实体" sortable="true"></el-table-column>
									<el-table-column prop="fileStatus" label="当前状态" sortable="true" align="center">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatAuditStatusImgList" :key="index">
												<img v-if="scoped.row.fileStatus == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template> 	
									</el-table-column>
									<el-table-column prop="fileStatus" label="人工验证" width="80">
										<template slot-scope="scope">
											<div v-if="scope.row.fileStatus == '1'" style="text-align: center;">
												<i class="el-icon-check" style="color: #84b944;font-size: 20px;font-weight: bold;"></i>
											</div>
											<div v-else-if="scope.row.fileStatus == '2'" style="text-align: center;">
												<i class="el-icon-close" style="color: red;font-size: 20px;font-weight: bold;"></i>
											</div>
										</template>
									</el-table-column>
								</el-table>
								<div class="pagination">
									<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
									<el-pagination
										@size-change="(val) => handleSizeChange('accvoucherpwm', val)"
										@current-change="(val) => handleCurrentChange('accvoucherpwm', val)"
										:current-page="accvoucherpwm.page"
										:page-size="accvoucherpwm.limit"
										:page-sizes="accvoucherpwm.limits"
										layout="total, sizes, prev, pager, next, jumper"
										:total="accvoucherpwm.count">
									</el-pagination>
								</div>
							</el-col>
							<el-col :span="8">
								<el-card class="box-card" style="height: 500px;margin-left:20px;overflow-y: scroll;">
									<div class="voucher-tag-title" style="margin-bottom: 10px;">凭证影像</div>
									<div>
										<!-- <img :src="require('../../../assets/img/voucher_demo.jpg')"  width="90%"> -->
										<accvoucher ref="accvoucher"></accvoucher>
									</div>
									<div class="voucher-tag-title" style="margin: 15px 0px;">验证信息</div>
									<el-form :model="accVoucherAuthInfoForm">
										<div class="voucher-tag-contmg" style="margin: 10px 0px;">
											<div style="margin-bottom: 10px">系统验证时间：{{this.timestampFormatter(accVoucherAuthInfoForm.sysAuthTime)}}</div>
											<div style="margin-bottom: 10px">系统验证详情：{{accVoucherAuthInfoForm.sysAuthMsg}}</div>
											<div style="margin-bottom: 10px">人工验证时间：{{this.timestampFormatter(accVoucherAuthInfoForm.manualAuthTime)}}</div>
											<div>人工验证详情：{{accVoucherAuthInfoForm.manualAuthMsg}}</div>
										</div>
									</el-form>
								</el-card>
							</el-col>
						</el-row>
					</div>
				</el-tab-pane>
				<el-tab-pane label="原始凭证" name="2">
					<div style="display: flex;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">凭证类型</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in voucherTypeImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="voucherTypeImgClickFun($event, index)">
						</div>
					</div>
					<div style="display: flex;padding-top: 12px;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">审核状态</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in oriVoucherAuditStatusImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="($event) => auditStatusImgClickFun($event, index, 'oriVoucherAuditStatusImgList')">
						</div>
					</div>
					<el-divider></el-divider>
					<div style="display: flex;">
						<div style="width: 60%;">
							<!-- <el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;"><i class="el-icon-arrow-up" style="font-size: 20px;font-weight: bold;"></i></el-button>
							<el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;"><i class="el-icon-arrow-down" style="font-size: 20px;font-weight: bold;"></i></el-button> -->
							<el-button type="primary" @click="pushVoucherInvoiceVerify()">提交验证</el-button>
							<el-button plain @click="setOriVoucherPassed"><i class="el-icon-check" style="color: #84b944;font-size: 14px;font-weight: bold;"></i> 审核通过</el-button>
							<el-button plain @click="setOriVoucherDeny"><i class="el-icon-close" style="color: #d0303e;font-size: 14px;font-weight: bold;"></i> 审核拒绝</el-button>
							<!-- <el-button plain @click="deleteOriVoucher" style="width: 80px;">删除</el-button> -->
						</div>
						<div style="width: 40%;">
							<div style="float: right;">
								<el-input v-model="oriVoucherValidationSearchName" placeholder="凭证号码、价税合计、所属实体" style="width:350px;margin-bottom:5px" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryOriVoucherValidationData"/>
							</div>
						</div>
					</div>
					<div style="margin-top: 8px;">
						<el-row>
							<el-col :span="16">
								<el-table ref="oriVoucherValidationTable" :data="oriVoucherValidationTableData" border stripe class="table" @row-click="(row) => clickRowByChecked('oriVoucherValidationTable', row)" height="500px" :highlight-current-row="true">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="voucherType" label="凭证类型" align="center" width="100">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatVoucherTypeImgList" :key="index">
												<img v-if="scoped.row.voucherType == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="voucherNo" label="凭证号码" sortable="true" width="120"></el-table-column>
									<el-table-column prop="amount" label="凭证金额" sortable="true" width="120" :formatter="(row, column, cellValue, index) => this.formatAmountSeparator(cellValue)"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证日期" sortable="true" width="140" :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
									<el-table-column prop="fileType" label="文件格式" sortable="true" width="110"></el-table-column>
									<el-table-column prop="companyName" label="所属实体" sortable="true" width="120"></el-table-column>
									<el-table-column prop="fileStatus" label="当前状态" sortable="true" align="center" width="120">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatAuditStatusImgList" :key="index">
												<img v-if="scoped.row.fileStatus == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template> 	
									</el-table-column>
									<el-table-column prop="authStatus" label="发票查验" width="80">
										<template slot-scope="scope">
											<div v-if="scope.row.authStatus == '1'" style="text-align: center;">
												<i class="el-icon-loading" style="font-size: 20px;font-weight: bold;"></i>
											</div>
											<div v-if="scope.row.authStatus == '2'" style="text-align: center;">
												<i class="el-icon-check" style="color: #84b944;font-size: 20px;font-weight: bold;"></i>
											</div>
											<div v-else-if="scope.row.authStatus == '3'" style="text-align: center;">
												<i class="el-icon-close" style="color: red;font-size: 20px;font-weight: bold;"></i>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="invoiceSourceType" label="发票源文件" width="120" sortable="true">
                    <template slot-scope="scope">
                      <div v-if="scope.row.invoiceSourceType === '0'" style="text-align: center;">
                        <i class="el-icon-check" style="color: #84b944;font-size: 20px;font-weight: bold;"></i>
                      </div>
                      <div v-else-if="scope.row.invoiceSourceType === '1'" style="text-align: center;">
                        <i class="el-icon-close" style="color: red;font-size: 20px;font-weight: bold;"></i>
                      </div>
                    </template>
                  </el-table-column>
									<el-table-column prop="fileStatus" label="人工验证" width="80">
										<template slot-scope="scope">
											<div v-if="scope.row.fileStatus == '1'" style="text-align: center;">
												<i class="el-icon-check" style="color: #84b944;font-size: 20px;font-weight: bold;"></i>
											</div>
											<div v-else-if="scope.row.fileStatus == '2'" style="text-align: center;">
												<i class="el-icon-close" style="color: red;font-size: 20px;font-weight: bold;"></i>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="invoiceSourceDesc" label="发票源文件描述" width="180" sortable="true"></el-table-column>
                  <el-table-column prop="sysAuthMsg" label="发票查验描述"  width="180" sortable="true"></el-table-column>
								</el-table>
								<div class="pagination">
									<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
									<el-pagination
										@size-change="(val) => handleSizeChange('orivoucherpwm', val)"
										@current-change="(val) => handleCurrentChange('orivoucherpwm', val)"
										:current-page="orivoucherpwm.page"
										:page-size="orivoucherpwm.limit"
										:page-sizes="orivoucherpwm.limits"
										layout="total, sizes, prev, pager, next, jumper"
										:total="orivoucherpwm.count">
									</el-pagination>
								</div>
							</el-col>
							<el-col :span="8">
								<el-card class="box-card" style="height: 500px;margin-left:20px;overflow-y: scroll;">
									<div class="voucher-tag-title" style="margin-bottom: 10px;">凭证影像</div>
									<div>
										<div id ="otherTypeText" style="font-size: 20px;color:red;display:none">该文件类型暂不支持预览，请下载查看</div>
										<img id="orivoucherImg" src="" width="100%" height="340px">
										<iframe src="" id="oriv_pdf_frame" width="100%" height="400px" frameborder="no" scrolling="yes" style="overflow-y:scroll;display:none;"></iframe>
									</div>
									<!-- <div style="box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);margin-bottom: 15px;">
										<img src="../../../assets/img/voucher_demo.jpg" width="98%" height="60%" style="margin: 5px;" @click="previewVoucherImg()">
										<el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[voucherUrl]"/>
									</div> -->
									<div class="voucher-tag-title" style="margin: 15px 0px;">验证信息</div>
									<el-form :model="oriVoucherAuthInfoForm">
										<div class="voucher-tag-contmg" style="margin: 10px 0px;">
											<div style="margin-bottom: 10px">系统验证时间：{{this.timestampFormatter(oriVoucherAuthInfoForm.sysAuthTime)}}</div>
											<div style="margin-bottom: 10px">系统验证详情：{{oriVoucherAuthInfoForm.sysAuthMsg}}</div>
											<div style="margin-bottom: 10px">人工验证时间：{{this.timestampFormatter(oriVoucherAuthInfoForm.manualAuthTime)}}</div>
											<div>人工验证详情：{{oriVoucherAuthInfoForm.manualAuthMsg}}</div>
										</div>
									</el-form>
								</el-card>
							</el-col>
						</el-row>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		
		<!-- 审核拒绝原因 dialog -->
		<el-dialog title="审核拒绝" :visible.sync="auditRefuseDialogVisible" width="30%" top="40vh" :close-on-click-modal="false">
			<div class="custom-dialog" style="height: 110px;">
				<el-form :model="auditRefuseForm" style="padding:2%">
					<div style="display:flex;">
						<label style="color: #606266;width:100px;line-height:85px">拒绝原因</label>
						<el-input type="textarea" :rows="4" v-model="auditRefuseForm.refuseMessage"></el-input>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveAuditRefuseClickFun()" style="width: 80px;">确认</el-button>
                <el-button @click="auditRefuseDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
export default {
	name: 'basetable',
	components: { ElImageViewer },
	data() {
		return {
			voucherValidationTabs: "1",
			accvoucherpwm: JSON.parse(JSON.stringify(this.pageobj)),
			orivoucherpwm: JSON.parse(JSON.stringify(this.pageobj)),
			voucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			formatVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			formatAccVoucherTypeImgList: JSON.parse(JSON.stringify(this.accountingVoucherTypeList)),
			accVoucherAuditStatusImgList: JSON.parse(JSON.stringify(this.auditStatusList)),
			oriVoucherAuditStatusImgList: JSON.parse(JSON.stringify(this.auditStatusList)),
			formatAuditStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),
			accVoucherValidationSearchName: '',
			oriVoucherValidationSearchName: '',
			accVoucherValidationTableData: [],
			oriVoucherValidationTableData: [],
			oriVoucherAuthInfoForm: {manualAuthTime:'',manualAuthMsg:'',sysAuthTime:'',sysAuthMsg:''},
			accVoucherAuthInfoForm: {manualAuthTime:'',manualAuthMsg:'',sysAuthTime:'',sysAuthMsg:''},
			auditRefuseDialogVisible: false,
			auditRefuseForm: {
				refuseMessage: ''
			},
			showViewer: false,
			voucherUrl: '../../../assets/img/voucher_demo.jpg',
			accvoucherId: ''	//	记账凭证ID
		};
	},
	created: function() {
		//	加载数据
		this.loadVoucherValidationData();
	},
	methods: {
		refresh() {
			this.loadVoucherValidationData();
		},
		handleSizeChange(pwmName, val) {
			this[pwmName].limit = val;
			this.loadVoucherValidationData();
		},
		handleCurrentChange(pwmName, val) {
			this[pwmName].page = val;
			this.loadVoucherValidationData();
		},
		clickRowByChecked(refTableName, row) {
			this.$refs[refTableName].toggleRowSelection(row);
			if(this.voucherValidationTabs == '1') {
				this.getAccVoucherInfoById(row.id);
				this.showAccVoucherFile(row.id);	//	显示记账凭证表格信息
			} else if(this.voucherValidationTabs == '2') {
				this.getOriVoucherInfoById(row.id);
			}
		},
		async getCheckVoucherCondition() {	//	获取页面默认勾选条件
			//	勾选的凭证类型
			let checkVoucherTypeList = [];
			if(this.voucherValidationTabs == '2') {
				this.voucherTypeImgList.forEach(typeObj => {
					if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
						checkVoucherTypeList.push(typeObj.code);
					}
				});
			}

			//	勾选的文件状态
			let checkAuditStatusList = [];
			let auditStatusImgList = [];
			if(this.voucherValidationTabs == '1') {	//	记账凭证
				auditStatusImgList = this.accVoucherAuditStatusImgList;
			} else if(this.voucherValidationTabs == '2') {
				auditStatusImgList = this.oriVoucherAuditStatusImgList;
			}
			auditStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkAuditStatusList.push(statusObj.code);
				}
			});

			if(this.voucherValidationTabs == '1') {
				this.accvoucherpwm.search = { 'fileStatusList': checkAuditStatusList.join(',') };
			} else if(this.voucherValidationTabs == '2') {
				this.orivoucherpwm.search = { 'voucherTypeList': checkVoucherTypeList.join(','), 'fileStatusList': checkAuditStatusList.join(',') };
			}
		},
		async getAccVoucherValidationListData() {	//	加载记账凭证头数据
			this.accvoucherpwm.likeSearch = this.accVoucherValidationSearchName;
			await fetchPost('/verify/getVerifyAccVoucherList', this.accvoucherpwm).then(res => {
				this.accVoucherValidationTableData = res.data.data;
				this.accvoucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载记账凭证数据失败：' + error);
			});
		},
		async loadAccVoucherValidationData() {
			this.getCheckVoucherCondition();
			this.getAccVoucherValidationListData().then(data => {
				if(this.accVoucherValidationTableData && this.accVoucherValidationTableData.length > 0) {
					//	默认选中第一条，并显示详情
					let firstData = this.accVoucherValidationTableData[0];
					// this.clickRowByChecked('accVoucherValidationTable', firstData);
					this.getAccVoucherInfoById(firstData.id);
					this.showAccVoucherFile(firstData.id);	//	显示记账凭证表格信息
				}
			});
		},
		async getOriVoucherValidationListData() {	//	加载原始凭证数据
			this.orivoucherpwm.likeSearch = this.oriVoucherValidationSearchName;
			await fetchPost('/verify/getVerifyOriVoucherList', this.orivoucherpwm).then(res => {
				this.oriVoucherValidationTableData = res.data.data;
				this.orivoucherpwm.count = res.data.count;
			}, error => {
				this.$message.error('加载原始凭证数据失败：' + error);
			});
		},
		async loadOriVoucherValidationData() {	//	load accvoucher table
			this.getCheckVoucherCondition();
			this.getOriVoucherValidationListData().then(data => {
				if(this.oriVoucherValidationTableData && this.oriVoucherValidationTableData.length > 0) {
					//	默认选中第一条，并显示详情
					// let firstData = this.oriVoucherValidationTableData[0];
					// this.clickRowByChecked('oriVoucherValidationTable', firstData);
				}
			});
		},
		async loadVoucherValidationData() {
			if(this.voucherValidationTabs == '1') {
				this.loadAccVoucherValidationData();
			} else if(this.voucherValidationTabs == '2') {
				this.loadOriVoucherValidationData();
			}
		},
		async getAccVoucherInfoById(id) {
			await fetchPost('/verify/getAccVoucherInfoById', id).then(res => {
				if(res.data.success) {
					this.accVoucherAuthInfoForm = res.data.obj;
				} else {
					this.$message.error(res.data.message);	
				}
			}, error => {
				this.$message.error(error);
			});
		},
		async getOriVoucherInfoById(id) { // 凭证影像、验证信息
			await fetchPost('/verify/getOriVoucherInfoById', id).then(res => {
				if(res.data.success) {
					this.oriVoucherAuthInfoForm = res.data.obj;
					this.showVoucherFile(id);
				} else {
					this.$message.error(res.data.message);	
				}
			}, error => {
				this.$message.error(error);
			});
		},
		fuzzyQueryAccVoucherValidationData() {
			this.loadAccVoucherValidationData();
		},
		fuzzyQueryOriVoucherValidationData() {	//	模糊查询
			this.loadOriVoucherValidationData();
		},
		voucherTypeImgClickFun(event, index) {	//	凭证类型点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this.voucherTypeImgList[index].name = imgName + '-h';
			} else {
				this.voucherTypeImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}

			let checkVoucherTypeList = [];
			this.voucherTypeImgList.forEach(typeObj => {
				if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
					checkVoucherTypeList.push(typeObj.code);
				}
			});
			if(!checkVoucherTypeList || checkVoucherTypeList.length == 0) {
				this.$message.error('至少需要展示一个凭证类型！');
				this.voucherTypeImgList[index].name = imgName;
				return false;
			}
			
			this.loadOriVoucherValidationData();
		},
		auditStatusImgClickFun(event, index, auditStatusImgListName) {	//	审核状态点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this[auditStatusImgListName][index].name = imgName + '-h';
			} else {
				this[auditStatusImgListName][index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}
			let checkAuditStatusList = [];
			this[auditStatusImgListName].forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkAuditStatusList.push(statusObj.code);
				}
			});
			if(!checkAuditStatusList || checkAuditStatusList.length == 0) {
				this.$message.error('至少需要展示一个审核状态！');
				this[auditStatusImgListName][index].name = imgName;
				return false;
			}

			this.loadVoucherValidationData();
		},
		pushVoucherInvoiceVerify() { // 发票查验
			let checkRows = this.$refs.oriVoucherValidationTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要提交验证的记录！');
				return;
			}
			let voucherIdList = [];
			checkRows.forEach(row => {
				voucherIdList.push(row.id);
			});
			this.$confirm('是否将选中记录提交验证？', '提示', { type: 'info' }).then(res => {
				fetchPost("/verify/verifyInvoiceOriVoucher", voucherIdList.join(',')).then(res => {
					if(res.data.success) {
						this.$message.success(res.data.message);
						this.loadVoucherValidationData();
					} else {
						this.$message.error('提交验证失败：' + res.data.message);
						this.loadVoucherValidationData();
					}
				}, error => {
					this.$message.error('提交验证失败：' + error);
				});
			});
		},
		async getTableCheckRows() {
			let checkRows = [];
			if(this.voucherValidationTabs == '1') {
				checkRows = this.$refs.accVoucherValidationTable.selection;
			} else if(this.voucherValidationTabs == '2') {
				checkRows = this.$refs.oriVoucherValidationTable.selection;
			}
			return checkRows;
		},
		setOriVoucherPassed() { // 审核通过
			this.getTableCheckRows().then(checkRows => {
				let passedUrl = "";
				if(this.voucherValidationTabs == '1') {
					passedUrl = "/verify/setAccVoucherPassed";
				} else if(this.voucherValidationTabs == '2') {
					passedUrl = "/verify/setOriVoucherPassed";
				}
				if(!checkRows || checkRows.length == 0) {
					this.$message.error('请选择需要人工审核通过的记录！');
					return;
				}
				let voucherIdList = [];
				for (let i = 0; i < checkRows.length; i++) {
					const row = checkRows[i];
					if(row.fileStatus != '0' && row.fileStatus != '2') {
						this.$message.error("只能选择'已上传'、'验证拒绝'状态的凭证！");
						return;
					}
					voucherIdList.push(row.id);
				}
				fetchPost(passedUrl, voucherIdList.join(',')).then(res => {
					if(res.data.success) {
						this.$message.success('人工审核通过成功！');
						this.loadVoucherValidationData();
					} else {
						this.$message.error('人工审核通过失败：' + res.data.message);
					}
				}, error => {
					this.$message.error('人工审核通过失败：' + error);
				});
			});
		},
		setOriVoucherDeny() { // 审核拒绝
			this.getTableCheckRows().then(checkRows => {
				if(!checkRows || checkRows.length == 0) {
					this.$message.error('请选择需要人工审核拒绝的记录！');
					return;
				}
				for (let i = 0; i < checkRows.length; i++) {
					const row = checkRows[i];
					if(row.fileStatus != '0' && row.fileStatus != '1') {
						this.$message.error("只能选择'已上传'、'验证成功'状态的凭证！");
						return;
					}
				}
				this.auditRefuseDialogVisible = true;
			});
		},
		saveAuditRefuseClickFun() {	//	审核拒绝 - 拒绝原因
			this.getTableCheckRows().then(checkRows => {
				let voucherIdList = [];
				checkRows.forEach(row => {
					voucherIdList.push(row.id);
				});
				let refuseUrl = "";
				if(this.voucherValidationTabs == '1') {
					refuseUrl = "/verify/setAccVoucherDeny";
				} else if(this.voucherValidationTabs == '2') {
					refuseUrl = "/verify/setOriVoucherDeny";
				}
				let params = {ids: voucherIdList.join(','), msg: this.auditRefuseForm.refuseMessage};
				fetchPost(refuseUrl, params).then(res => {
					if(res.data.success) {
						this.$message.success('人工审核拒绝成功！');
						this.auditRefuseDialogVisible = false;
						this.auditRefuseForm.refuseMessage = '';
						this.loadVoucherValidationData();
					} else {
						this.$message.error('人工审核拒绝失败：' + res.data.message);
					}
				}, error => {
					this.$message.error('人工审核拒绝失败：' + error);
				});
			});
		},
		deleteOriVoucher() { // 删除原始凭证
			this.getTableCheckRows().then(checkRows => {
				if(!checkRows || checkRows.length == 0) {
					this.$message.error('请选择需要删除的原始凭证！');
					return;
				}
				let voucherIdList = [];
				for (let i = 0; i < checkRows.length; i++) {
					const row = checkRows[i];
					if(row.fileStatus != '0' && row.fileStatus != '1' && row.fileStatus != '2') {
						this.$message.error("只能删除'已上传'、'验证通过'、'验证拒绝'状态的凭证！");
						return;
					}
					voucherIdList.push(row.id);
				}
				let deleteUrl = "";
				if(this.voucherValidationTabs == '1') {
					deleteUrl = "/verify/deleteAccVoucher";
				} else if(this.voucherValidationTabs == '2') {
					deleteUrl = "/verify/deleteOriVoucher";
				}
				this.$confirm('是否删除将选中的凭证？', '提示', { type: 'info' }).then(res => {
					fetchPost(deleteUrl, voucherIdList.join(',')).then(res => {
						if(res.data.success) {
							this.$message.success('删除成功！');
							this.loadVoucherValidationData();
						} else {
							this.$message.error('删除失败：' + res.data.message);
						}
					}, error => {
						this.$message.error('删除失败：' + error);
					});
				});
			});
		},
		showVoucherFile(id) { //  显示原始凭证文件
			let fileName = this.oriVoucherAuthInfoForm.fileName;
			let fileType = fileName.substr(fileName.lastIndexOf('.') + 1);
			let image = document.getElementById("orivoucherImg");
			let iframe = document.getElementById('oriv_pdf_frame');
			let otherType = document.getElementById('otherTypeText');
			let tokenParam = "&token=" + localStorage.getItem('token');
			if(fileType.toLowerCase() == 'jpg' || fileType.toLowerCase() == 'png') {
				image.style = "display:block";
				iframe.style = "display:none";
				otherType.style = "display:none";
				image.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + tokenParam;
			} else if(fileType.toLowerCase() == 'pdf') {
				image.style = "display:none";
				iframe.style = "display:block";
				otherType.style = "display:none";
				iframe.src = this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + tokenParam;
			} else if(fileType.toLowerCase() == 'ofd') {
				image.style = "display:none";
				iframe.style = "display:block";
				otherType.style = "display:none";
				iframe.src = this.ofdReaderPath + '/ofd/reader?file=' + this.baseURL + "/archival/getOriginalVoucherDataById?id=" + id + "%26token=" + localStorage.getItem("token");
			} else if(fileType.toLowerCase() == 'zip') {
				otherType.style = "display:block";
				image.style = "display:none";
				iframe.style = "display:none";
			} else {
				console.log(fileType)
				this.$message.error('错误的文件类型，不支持查看！');
				return;
			}
		},
		showAccVoucherFile(accvoucherId) {	//	显示凭证文件
			this.$refs.accvoucher.getAccountVoucherDataById(accvoucherId);
		},
		previewVoucherImg() {	//	点击凭证图片放大预览
			this.showViewer = true;
		},
		closeViewer() {	//	关闭查看器
			this.showViewer = false;
		}
	},
	watch: {
		'voucherValidationTabs': function(val) {
			if(val == '1') {
				this.loadAccVoucherValidationData();
			} else if(val == '2') {
				this.loadOriVoucherValidationData();
			}
		}
	}
};

</script>
<style scoped>
.table {
	width: 100%;
	font-size: 14px;
}
#archivesInv .el-main {
    padding: 0 0 0 0 !important;
}
.dialog-custom .el-dialog__body div{
	padding: -10px 0 0 10px !important;
}
.voucher-tag-title {
	font-size:14px;
	font-weight:bold;
	line-height: 25px;
    color: #66b1ff;
}
.voucher-tag-contmg {
	font-size: 12px;
	color:#909399;
}

/* 覆盖记账凭证样式 */
>>> .av-container {
	height: 41vh;
}
>>> .av-header-title {
	font-size: 0.8rem;
}
>>> .av-header-title-line {
	font-size: 0.5em;
}
>>> .av-header-voucherno {  /* 凭证号 */
	font-size: 0.6em;
}
>>> .av-header-content {    /* 所属实体、凭证日期、erp凭证号 */
	font-size: 0.5em;
}
>>> .av-content {
	font-size: 0.5em
}
>>> .av-content-header-row {
	line-height: 5vh;
}
>>> .av-content-header-split-row {
	height: 2.5vh;
	line-height: 2.5vh;
}
>>> .av-text-align-l {
	padding: 5px 0px 0px 2px;
}
>>> .av-content-detail-row-h {
	height: 5vh;
	line-height: 5vh;
}
>>> .av-line-height {
	line-height: 2vh;
}
>>> .av-footer {
	font-size: 0.5em;
}
</style>